// Square Web Payments SDK credentials for the checkout / card-update forms.
//
// Per-environment values come from the BUILD, not the runtime: release.yaml
// passes REACT_APP_SQUARE_APP_ID / REACT_APP_SQUARE_LOCATION_ID from the
// GitHub Environment (stage → Square SANDBOX app + location, prod → live
// values). This is what makes a full end-to-end checkout testable on
// stage.mygolfdna.com with Square sandbox test cards (MGDWD-177): before
// this, stage tokenized cards against LIVE Square while the stage API talked
// to the sandbox, so stage payments could never complete.
//
// The fallbacks are the production values so a missing variable can never
// break the live checkout; the NODE_ENV branch for the location mirrors the
// previous hardcoded behavior for local dev builds.
export const SQUARE_APP_ID =
	process.env.REACT_APP_SQUARE_APP_ID || "sq0idp-O1UZkb9lgaV2KS1vEm5TEA";

export const SQUARE_LOCATION_ID =
	process.env.REACT_APP_SQUARE_LOCATION_ID ||
	(process.env.NODE_ENV === "production" ? "4F2E7F3QP3YD5" : "L36AG5ZKTWKGM");
